import './CourseItemCard.less';
import React from 'react';
import ImageView from "../../components/image-view/ImageView";
import __ from "../../i18n";
import {Link} from "react-router-dom";
import routes from "../../routing/routes";


export default function CourseItemCard({course, creator, avatarImage, promotionalAvatarImage = null, promotion = null, type = 'view'}) {

    let salePrice = course.price;
    if (promotion !== null) {
        salePrice = Math.floor(course.price * (100 - promotion.discount_percentage) / 100);
    }

    const getUrl = () => {
        if (type === 'view') {
            return routes.course.getUrl(course.slug);
        }

        if (type === 'learn') {
            return routes.learning.getUrl(course.id, 0);
        }

        if (type === 'checkout') {
            return routes.checkout.getUrl('course', course.id);
        }
    };

    const bottom = () => {
        if (type === 'view') {
            return <div className="price">
                <span className="sale-price">
                    {__('::price(CURRENCY, symbol)', {price: salePrice})}
                </span>
                {
                    promotion !== null &&
                    course.price > 0 &&
                    <span className="discount">
                        {__('-::percentage%', {percentage: promotion.discount_percentage})}
                    </span>
                }
            </div>;
        }

        if (type === 'learn') {
            return <div className="learn">{__('Learn now')}</div>
        }

        if (type === 'checkout') {
            return <div className="pending">{__('Awaiting payment')}</div>;
        }
    };

    const image = promotion !== null && promotionalAvatarImage !== null ? promotionalAvatarImage : avatarImage;

    return <Link className="course-item-card" to={getUrl()}>
        <ImageView
            image={image}
            ratio={1.5}
        />
        <div className="name">{course.name}</div>
        <div className="creator">{creator.full_name}</div>
        {bottom()}
    </Link>;
}
